import { DistinctValue } from "../../../types";
import { DistinctValuesResponse } from "../../../services/cleaning-data-service";

/**
 * Transforms the API response for distinct values into a flat array of DistinctValue objects.
 * Each value is assigned a unique ID based on category, index, and value.
 */
const transformDistinctValuesResponse = (
  data: DistinctValuesResponse | undefined,
): DistinctValue[] => {
  if (!data?.results) {
    return [];
  }

  const mappedValues: DistinctValue[] = [];

  data.results.forEach(
    (categoryResult: {
      result: number;
      distinctValues: { value: string }[];
    }) => {
      categoryResult.distinctValues.forEach((item, index) => {
        mappedValues.push({
          id: `${categoryResult.result}-${index}-${item.value}`,
          value: item.value,
          label: item.value,
          categoryId: categoryResult.result,
        });
      });
    },
  );

  return mappedValues;
};

export default transformDistinctValuesResponse;
